import * as React from 'react';

import CancelIcon from '@mui/icons-material/Cancel';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { black, gray } from '../../constants/Colors';

const styles = {
  divider: {
    backgroundColor: '#DBDBE0',
    color: black
  }
};

interface Props {
  fileName: string;
  index: number;
  deleteFunc: (i: number, name: string) => void;
  download: (i: number, name: string) => void;
}

export default function CustomFileDownload(props: Props): React.ReactElement {
  const { t } = useTranslation();
  const { fileName, index, deleteFunc, download } = props;

  let name;
  if (
    fileName.match(/issues\/.*\/image\//g) ??
    fileName.match(/medias\/.*\/file\//g)
  ) {
    const text = fileName.match(/[0-9]{13}_|[0-9]{14}_/g);
    name = fileName.substring(
      text ? fileName.indexOf(text[0]) + text[0].length : 0
    );
  } else {
    name = fileName;
  }

  return (
    <Typography key={index} component="div">
      <Typography key={index} component="div">
        <Grid container alignItems="center">
          <Grid item xs={1}>
            <IconButton
              onClick={() => {
                deleteFunc(index, fileName);
              }}
              component="label"
            >
              <CancelIcon sx={{ color: 'rgba(0, 0, 0, 0.6);' }} />
            </IconButton>
          </Grid>
          <Grid item xs={7} sx={{ paddingLeft: '10px' }}>
            <Typography
              sx={{ fontSize: '14px' }}
              color={black}
              component="span"
            >
              {name}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Grid container justifyContent="flex-end">
              <Button
                onClick={() => {
                  download(index, fileName);
                }}
                value="download"
              >
                <FileDownloadOutlinedIcon sx={{ color: gray }} />
                <Typography
                  sx={{ fontSize: '14px' }}
                  color={gray}
                  component="span"
                >
                  {t('orientation.download')}
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Typography>
      <Divider light sx={styles.divider} />
    </Typography>
  );
}
